import { styled } from "@mui/material/styles";
import { BodyTextS } from "./Typography";

export const VersionText = styled(BodyTextS)(({ theme }) =>
    theme.unstable_sx({
        textAlign: "right",
        mt: 2,
    }),
);
